import { legacyPlugins } from "/opt/buildhome/repo/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}